import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useCart } from '../context/CartContext';

function CartFeedback() {
  const { feedback, closeFeedback } = useCart();

  return (
    <Snackbar
      key={feedback.id}
      open={feedback.open}
      autoHideDuration={2200}
      onClose={() => closeFeedback(feedback.id)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{
        bottom: { xs: 88, sm: 96 },
      }}
    >
      <Alert
        onClose={() => closeFeedback(feedback.id)}
        severity={feedback.severity}
        variant="filled"
        sx={{
          width: '100%',
          borderRadius: 3,
          fontWeight: 700,
          boxShadow: '0 14px 30px rgba(0,0,0,0.14)',
        }}
      >
        {feedback.message}
      </Alert>
    </Snackbar>
  );
}

export default CartFeedback;
